import {
  EventId,
  ClickButtonSchema,
  ScreenViewSchema,
  ErrorSchema,
  HeartBeatSchema,
} from '@pegaxy/event-tracking-webworker';
import type TrackingClient from '@pegaxy/event-tracking-webworker';

export const trackingScreenViewEvents = {
  SCREEN_VIEW: 'screen-view',
};

export const trackingHeartBeatEvents = {
  HEART_BEAT: 'heart-beat',
};

export const trackingErrorEvents = {
  ERROR_EXAMPLE: 'error-example',
};

type TrackingUser = {
  address: string;
};

export const sendButtonClickTrackingEvent =
  (trackingClient: TrackingClient, trackingUser?: TrackingUser) =>
  (
    eventName: string,
    extra?: { targetUrl?: string; data?: { [key: string]: unknown } },
  ) => {
    trackingClient.pushWebLog<ClickButtonSchema>(
      {
        createdAt: Math.floor(Date.now() / 1000),
        eventId: EventId.ClickButton,
        eventType: 'webButtonClickEvent',
        eventName,
        href: window.location.href,
        targetUrl: extra?.targetUrl ? extra.targetUrl : '',
        extraJson: extra?.data ? JSON.stringify(extra?.data) : '',
      },
      trackingUser,
    );
  };

export const sendScreenViewTrackingEvent =
  (trackingClient: TrackingClient, trackingUser?: TrackingUser) =>
  <K extends keyof typeof trackingScreenViewEvents>(
    eventName: K,
    loadStart: number,
    loadEnd: number,
    screenName: string,
    extra?: { data?: string },
  ) => {
    trackingClient.pushWebLog<ScreenViewSchema>(
      {
        createdAt: Math.floor(Date.now() / 1000),
        eventId: EventId.ScreenView,
        eventType: 'webScreenViewEvent',
        eventName: trackingScreenViewEvents[eventName],
        href: window.location.href,
        loadEnd: loadEnd,
        loadStart: loadStart,
        screenName: screenName,
        extraJson: extra?.data ? JSON.stringify(extra?.data) : '',
      },
      trackingUser,
    );
  };

export const sendHeartBeatTrackingEvent =
  (trackingClient: TrackingClient, trackingUser?: TrackingUser) =>
  <K extends keyof typeof trackingHeartBeatEvents>(
    eventName: K,
    extra?: { data?: string },
  ) => {
    trackingClient.pushWebLog<HeartBeatSchema>(
      {
        createdAt: Math.floor(Date.now() / 1000),
        eventId: EventId.HeartBeat,
        eventType: 'webHeartBeat',
        eventName,
        href: window.location.href,
        extraJson: extra?.data ? JSON.stringify(extra?.data) : '',
      },
      trackingUser,
    );
  };

export const sendErrorTrackingEvent =
  (trackingClient: TrackingClient, trackingUser?: TrackingUser) =>
  <K extends keyof typeof trackingErrorEvents>(
    eventName: K,
    apiCall: string,
    apiPayload: string,
    errorCode: string,
    errorMessage: string,
    extra?: { data?: string; errorEventId?: string; responseJson?: string },
  ) => {
    trackingClient.pushWebLog<ErrorSchema>(
      {
        createdAt: Math.floor(Date.now() / 1000),
        eventId: EventId.Error,
        eventType: 'webErrorEvent',
        eventName: trackingErrorEvents[eventName],
        href: window.location.href,
        apiCall: apiCall,
        errorMessage: errorMessage,
        errorCode: errorCode,
        apiPayload: apiPayload,
        errorEventId: extra?.errorEventId || '',
        responseJson: extra?.responseJson || '',
        extraJson: extra?.data ? JSON.stringify(extra?.data) : '',
      },
      trackingUser,
    );
  };
